import { get, post, deleteMethod, postJson, formatUrl } from '../../../utils/request'
import {
  LIST_NEW_NOTIFICAITON,
  NUMBER_NOTIFICAITON,
  REGISTER_FCM_DEVICE,
  UNREGISTER_FCM_DEVICE,
  MARK_READ_NOTIFICAITON
} from '../../../utils/urls'

const actions = {
  fetchListNotifications: async (context, payload) => {
    try {
      let response = await get(LIST_NEW_NOTIFICAITON, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListNotifications', response.data['results'])
        context.commit('setTotalNotifications', response.data['count'])
      }
    } catch (e) {
      context.commit('setListNotifications', [])
      context.commit('setTotalNotifications', 0)
    }
  },
  registerFCMDevice: async (context, payload) => {
    let tokenFirebase = JSON.parse(localStorage.getItem('token_firebase'))
    if (tokenFirebase && !tokenFirebase.isRegister) {
      const registerDevicePram = {
        name: 'web',
        registration_id: tokenFirebase.token,
        device_id: 'browser',
        type: 'web'
      }
      try {
        await post(REGISTER_FCM_DEVICE, registerDevicePram)
        tokenFirebase = { ...tokenFirebase, isRegister: true }
        localStorage.setItem('token_firebase', JSON.stringify(tokenFirebase))
      } catch (error) {
        console.error(error)
      }
    }
  },
  removeTokenFirebase: async (context, payload) => {
    try {
      const tokenFirebase = JSON.parse(localStorage.getItem('token_firebase'))
      let params = {
        registration_id: tokenFirebase.token
      }
      const url = formatUrl(UNREGISTER_FCM_DEVICE, params)
      localStorage.removeItem('token_firebase')
      await deleteMethod(url)
    } catch (error) {
      console.error(error)
    }
  },
  fetchNumberNotification: async (context, payload) => {
    try {
      let response = await get(NUMBER_NOTIFICAITON)
      let status = response.status
      if (status === 200) {
        context.commit('setNumberNotification', response.data['badge'])
      }
    } catch (e) {
      context.commit('setNumberNotification', 0)
    }
  },
  markReadNotifications: async (context, payload) => {
    return postJson(MARK_READ_NOTIFICAITON, payload.params)
  }
}

export default actions
